export const SECTION_NAME = 'summary_table_section';
